import { apolloClient } from 'App';

import { CreateRitualTemplateMutation, GetRitualTemplatesQuery } from 'data/__generated__';
import { GET_RITUAL_TEMPLATES_QUERY } from 'data/queries/ritualTemplates';

export const ritualTemplatesUpdatedHandler = (
    newRitualTemplate: NonNullable<CreateRitualTemplateMutation['createRitualTemplate']['ritualTemplate']>,
) => {
    const result = apolloClient.readQuery<GetRitualTemplatesQuery>({ query: GET_RITUAL_TEMPLATES_QUERY });
    if (!result) {
        return;
    }
    const { ritualTemplates: currentRitualTemplates } = result;

    const ritualTemplateIds = currentRitualTemplates.map(({ _id }) => _id);

    if (ritualTemplateIds.includes(newRitualTemplate._id)) {
        // If this is a ritualTemplate existing in the cache
        const data = currentRitualTemplates.map((ritualTemplate) => {
            if (ritualTemplate._id === newRitualTemplate._id) {
                return newRitualTemplate;
            }
            return ritualTemplate;
        });
        apolloClient.writeQuery({
            query: GET_RITUAL_TEMPLATES_QUERY,
            data,
        });
    } else {
        // If this is a new ritualTemplate, not present in the cache
        const data = {
            ritualTemplates: [...currentRitualTemplates, newRitualTemplate],
        };
        apolloClient.writeQuery({
            query: GET_RITUAL_TEMPLATES_QUERY,
            data,
        });
    }
};
